export default "__VITE_ASSET__BRbMTBuS__"